import type React from 'react'
import { useEffect } from 'react'

import { prefersReducedMotion } from '../../../../../utilities/misc/prefersReducedMotion'
import type { Images } from '../../imageType'

export const getScrollOffset = (bounds: Bounds) => {
  if (bounds.container && bounds.picture) {
    const containerCentrePoint = bounds.container.width / 2
    const pictureCentrePoint = bounds.picture.left + bounds.picture.width / 2
    const containerPositionOffset = bounds.container.left

    return pictureCentrePoint - containerCentrePoint - containerPositionOffset
  }
  return 0
}

export const getPictureByIndex = (node: HTMLUListElement | null, index: number) =>
  node?.querySelectorAll('picture')[index]

export const setScrollTo = ({ ref, current }: SetScrollToArgs) => {
  try {
    const bounds = {
      container: ref.current?.getBoundingClientRect(),
      picture: getPictureByIndex(ref.current, current)?.getBoundingClientRect(),
    }

    const left = (ref.current?.scrollLeft || 0) + getScrollOffset(bounds)
    ref.current?.scrollTo?.({
      top: 0,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      left,
    })
  } catch {
    // Do nothing.
  }
}

export const useScroller = ({ ref, current, images }: UseScrollerArgs) =>
  useEffect(() => setScrollTo({ ref, current }), [ref, current, images])

///////// IMPLEMENTATION /////////

type UseScrollerArgs = {
  ref: React.RefObject<HTMLUListElement>
  current: number
  images: Array<Images>
}

type SetScrollToArgs = {
  ref: React.RefObject<HTMLUListElement>
  current: number
}

type Bounds = {
  container?: DOMRectPick
  picture?: DOMRectPick
}

type DOMRectPick = Pick<DOMRect, 'width' | 'left'>
